"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FudaoDefinition_1 = require("./FudaoDefinition");
const DomainEvent_1 = require("../Engine/Event/DomainEvent");
class FudaoEvent {
    static TeacherStartInvitationSentEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherStartInvitationSent,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherStartInvitationCanceledEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherStartInvitationCanceled,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherEndInvitationSentEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherEndInvitationSent,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherEndInvitationCanceledEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherEndInvitationCanceled,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherTimePassedEvent(fudaoId, passedTime) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherTimePassed,
            entityId: fudaoId,
            body: passedTime,
        });
    }
    static TeacherExtendInvitationSentEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherExtendInvitationSent,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherExtendInvitationCanceledEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherExtendInvitationCanceled,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentStartInvitationReceivedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartInvitationReceived,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentStartInvitationAcceptedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartInvitationAccepted,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentStartInvitationRejectedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartInvitationRejected,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentStartInvitationNoResponseEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartInvitationNoResponse,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentEndInvitationReceivedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndInvitationReceived,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentEndInvitionAcceptedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndInvitationAccepted,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentEndInvitationRejectedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndInvitationRejected,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentEndInvitationNoResponseEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndInvitationNoResponse,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentExtendInvitationReceivedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentExtendInvitationReceived,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentExtendInvitionAcceptedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentExtendInvitationAccepted,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentExtendInvitationRejectedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentExtendInvitationRejected,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static StudentExtendInvitationNoResponseEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentExtendInvitationNoReponse,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static TeacherStartSessionInvitationCanceledEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherStartSessionInvitationCanceled,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static TeacherEndSessionInvitationCanceledEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.TeacherEndSessionInvitationCanceled,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentStartSessionInvitationReceivedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartSessionInvitationReceived,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentStartSessionInvitationAcceptedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartSessionInvitationAccepted,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentStartSessionInvitationRejectedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartSessionInvitationRejected,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentStartSessionInvitationNoResponseEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartSessionInvitationNoReponse,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentStartFudaoSessionReceivedEvent(fudaoId, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentStartFudaoSessionReceived,
            entityId: fudaoId,
            body: fs,
        });
    }
    static StudentEndSessionInvitationReceivedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndSessionInvitationReceived,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentEndSessionInvitionAcceptedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndSessionInvitationAccepted,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentEndSessionInvitationRejectedEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndSessionInvitationRejected,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static StudentEndSessionInvitationNoResponseEvent(fudaoDto, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.StudentEndSessionInvitationNoReponse,
            entityId: fudaoDto.id,
            body: fs,
        });
    }
    static FudaoStartedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoStarted,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static FudaoStartFailedEvent(fudaoDto, message) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoStartFailed,
            entityId: fudaoDto.id,
            body: message,
        });
    }
    static FudaoExtendedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoExtended,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static FudaoTimeUpEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoTimeUp,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static FudaoEndedEvent(fudaoDto) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoEnded,
            entityId: fudaoDto.id,
            body: fudaoDto,
        });
    }
    static FudaoSessionInitedEvent(fudaoId, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoSessionInited,
            entityId: fudaoId,
            body: fs,
        });
    }
    static FudaoSessionStartedEvent(fudaoId, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoSessionStarted,
            entityId: fudaoId,
            body: fs,
        });
    }
    static FudaoSessionFailedEvent(fudaoDtofudaoSessionAndMsg) {
        const fudaoDto = fudaoDtofudaoSessionAndMsg.Item1;
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoSessionFailed,
            entityId: fudaoDto.id,
            body: fudaoDtofudaoSessionAndMsg,
        });
    }
    static FudaoSessionNetworkQualityChangedEvent(fudaoId, fsAndNetworkQuality) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoSessionNetworkQualityChanged,
            entityId: fudaoId,
            body: fsAndNetworkQuality,
        });
    }
    static FudaoSessionEndedEvent(fudaoId, fs) {
        return new DomainEvent_1.DomainEvent({
            version: FudaoEvent.Version,
            category: FudaoEvent.Category,
            name: FudaoEvent.FudaoSessionEnded,
            entityId: fudaoId,
            body: fs,
        });
    }
}
FudaoEvent.Version = FudaoDefinition_1.FudaoVersion;
FudaoEvent.Category = FudaoDefinition_1.FudaoEventCategory;
/**
 * 老師已經送出開始輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherStartInvitationSent = "TeacherStartInvitationSent";
/**
 * 老師已經取消開始輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherStartInvitationCanceled = "TeacherStartInvitationCanceled";
/**
 * 老師已經送出結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherEndInvitationSent = "TeacherEndInvitationSent";
/**
 * 老師取消結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherEndInvitationCanceled = "TeacherEndInvitationCanceled";
/**
 * 輔導時間已經過了XX毫秒
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherTimePassed = "TeacherTimePassed";
/**
 * 老師已經送出延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherExtendInvitationSent = "TeacherExtendInvitationSent";
/**
 * 老師已經取消延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherExtendInvitationCanceled = "TeacherExtendInvitationCanceled";
/**
 * 老師已經取消開始Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherStartSessionInvitationCanceled = "TeacherStartSessionInvitationCanceled";
/**
 * 老師已經取消結束Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.TeacherEndSessionInvitationCanceled = "TeacherEndSessionInvitationCanceled";
/**
 *
 *
 * @static 學生已經收到老師的開始輔導邀請
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartInvitationReceived = "StudentStartInvitationReceived";
/**
 * 學生已經接受老師的開始輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartInvitationAccepted = "StudentStartInvitationAccepted";
/**
 * 學生已經拒絕老師的開始輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartInvitationRejected = "StudentStartInvitationRejected";
/**
 * 學生已經無回應老師的開始輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartInvitationNoResponse = "StudentStartInvitationNoResponse";
/**
 * 學生已經收到老師的結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndInvitationReceived = "StudentEndInvitationReceived";
/**
 * 學生已經接受老師的結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndInvitationAccepted = "StudentEndInvitationAccepted";
/**
 * 學生已經拒絕老師的結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndInvitationRejected = "StudentEndInvitationRejected";
/**
 * 學生已經無回應老師的結束輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndInvitationNoResponse = "StudentEndInvitationNoResponse";
/**
 * 學生已經收到老師的延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentExtendInvitationReceived = "StudentExtendInvitationReceived";
/**
 * 學生已經接受老師的延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentExtendInvitationAccepted = "StudentExtendInvitationAccepted";
/**
 * 學生已經拒絕老師的延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentExtendInvitationRejected = "StudentExtendInvitationRejected";
/**
 * 學生已經無回應老師的延長輔導邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentExtendInvitationNoReponse = "StudentExtendInvitationNoReponse";
/**
 * 學生已經收到老師的開始Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartSessionInvitationReceived = "StudentStartSessionInvitationReceived";
/**
 * 學生已經接受老師的開始Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartSessionInvitationAccepted = "StudentStartSessionInvitationAccepted";
/**
 * 學生已經拒絕老師的開始Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartSessionInvitationRejected = "StudentStartSessionInvitationRejected";
/**
 * 學生已經無回應老師的開始Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartSessionInvitationNoReponse = "StudentStartSessionInvitationNoReponse";
/**
 * 學生已經收到老師的結束Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndSessionInvitationReceived = "StudentEndSessionInvitationReceived";
/**
 * 學生已經接受老師的結束Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndSessionInvitationAccepted = "StudentEndSessionInvitationAccepted";
/**
 * 學生已經拒絕老師的結束Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndSessionInvitationRejected = "StudentEndSessionInvitationRejected";
/**
 * 學生無回應老師的結束Session邀請
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentEndSessionInvitationNoReponse = "StudentEndSessionInvitationNoReponse";
/**
 * 學生已經收到開始Session，代表此時老師端已經開始Session，學生端可以呼叫FudaoClientApplicationService.startFudaoSessionAsync加入Session
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.StudentStartFudaoSessionReceived = "StudentStartFudaoSessionReceived";
/**
 * 輔導已經開始
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoStarted = "FudaoStarted";
/**
 * 輔導已經失敗
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoStartFailed = "FudaoStartFailed";
//public static readonly FudaoExtendFailed = "FudaoExtendFailed";
//public static readonly FudaoEndFailed = "FudaoEndFailed";
/**
 * 輔導已經延長
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoExtended = "FudaoExtended";
/**
 * 輔導時間已經到了
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoTimeUp = "FudaoTimeUp";
/**
 * 輔導已經結束
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoEnded = "FudaoEnded";
FudaoEvent.FudaoUserOnlineStatusChanged = "FudaoUserOnlineStatusChanged";
/**
 * 輔導Session已經初始化
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoSessionInited = "FudaoSessionInited";
/**
 * 輔導Session已經開始
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoSessionStarted = "FudaoSessionStarted";
/**
 * 輔導Session的網路狀態改變
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoSessionNetworkQualityChanged = "FudaoSessionNetworkQualityChanged";
/**
 * 輔導Session已經失敗
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoSessionFailed = "FudaoSessionFailed";
/**
 * 輔導Session已經結束
 *
 * @static
 * @memberof FudaoEvent
 */
FudaoEvent.FudaoSessionEnded = "FudaoSessionEnded";
exports.FudaoEvent = FudaoEvent;
//# sourceMappingURL=FudaoEvent.js.map